import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "pb-3" }, "Add New Property", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "pb-3" }, "Property Type", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = {
  key: 0,
  class: "col-12 mb-3"
}
const _hoisted_9 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = {
  key: 0,
  type: "submit",
  class: "btn btn-fw btn-primary"
}
const _hoisted_13 = {
  key: 1,
  type: "submit",
  disabled: "true",
  class: "btn btn-fw btn-primary"
}
const _hoisted_14 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PartnerPropertyTypeSelector = _resolveComponent("PartnerPropertyTypeSelector")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_PartnerPropertyForm = _resolveComponent("PartnerPropertyForm")!

  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Field, {
          name: "type",
          class: "form-control"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PartnerPropertyTypeSelector, {
              onChangeSelection: _ctx.propertyTypeChange,
              initialValue: _ctx.initialValues?.partner_property_type
            }, null, 8, ["onChangeSelection", "initialValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_ErrorMessage, { name: "type" }),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_ctx.propertyType)
            ? (_openBlock(), _createBlock(_component_PartnerPropertyForm, {
                key: 0,
                initialValues: _ctx.initialValues,
                isNewProperty: _ctx.isNewProperty,
                propertyType: _ctx.propertyType,
                onOnCancel: _cache[0] || (_cache[0] = () => _ctx.$emit('onCancel'))
              }, null, 8, ["initialValues", "isNewProperty", "propertyType"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (!_ctx.propertyType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (!_ctx.isEmpty(_ctx.initialValues))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_12, " Update "))
                  : _createCommentVNode("", true),
                (_ctx.isEmpty(_ctx.initialValues))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_13, " Create "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-fw btn-outline-primary",
                  onClick: _cache[1] || (_cache[1] = () => _ctx.$emit('onCancel'))
                }, " Cancel ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}